// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title[data-v-2494c4aa]{-webkit-box-orient:vertical;-webkit-line-clamp:2;display:-webkit-box;min-height:2.6em}.image-container[data-v-2494c4aa]:after{content:\"\";display:block;padding-bottom:66.6666666667%;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
